// extracted by mini-css-extract-plugin
export var md = "_2z-4";
export var semantic = "_2z-5";
export var sm = "_2z-3";
export var text = "_2z-6";
export var toggleInput = "_2z-0";
export var toggleSwitch = "_2z-1";
export var xs = "_2z-2";